import { PagaduriasCondicionesHistoricosService } from "./../../../_services/pagadurias-condiciones-historicos.service";
import {
  MetodosCalculoCupo,
  TiemposDesfasesPagadurias,
  CodigosEstadosFuncionalidades,
} from "./../../../_enums/enum";
import { ListaItem } from "./../../../_models/lista-item";
import { PagaduriaCondicionHistorico } from "./../../../_models/pagaduria-condicion-historico";
import { CalendarioPropiedades } from "./../../../_models/calendario-propiedades";
import { CalendarioInformacion } from "./../../../_models/calendario-informacion";
import { PagaduriaCondicion } from "./../../../_models/pagaduria-condicion";
import { ListaService } from "./../../../_services/lista.service";
import { NavService } from "./../../../_services/_nav.service";
import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import { ConfirmationService, SelectItem,} from "primeng/api";
import { forkJoin } from "rxjs";
import { PagaduriasCondicionesService } from "./../../../_services/pagadurias-condiciones.service";
import { Pagaduria } from "./../../../_models/pagaduria";
import moment from 'moment';
import 'moment/locale/es';

@Component({
  selector: "app-pagaduria-condiciones-editar",
  templateUrl: "./pagaduria-condiciones-editar.component.html",
  styleUrls: ["./pagaduria-condiciones-editar.component.css"],
})
export class PagaduriaCondicionesEditarComponent implements OnInit {
  detalle = false;
  pagaduria: Pagaduria;
  pagaduriaCondicion: PagaduriaCondicion;
  pagaduriaCondicionComparar: PagaduriaCondicion;
  pagaduriasCondicionesHistoricos: PagaduriaCondicionHistorico[] = [];
  formulario: FormGroup;
  cargandoInformacion = true;
  lisTiempoDesfasesPagadurias: SelectItem[] = [];
  lisTiposFirmasAutorizaciones: SelectItem[] = [];
  lisMetodosCalculoCupo: SelectItem[] = [];
  listaMetodosCalculosTodos: ListaItem[] = [];
  listaTiposFirmasAutorizacionesTodos: ListaItem[] = [];
  listaTiempoDesfasesPagaduriasTodos: ListaItem[] = [];
  metodo: any;
  submitted: boolean;
  columnas: any[];
  carTabla = true;
  metodosCalculoCupo = MetodosCalculoCupo;
  comparacion = false;
  listadoPagaduriasCondiciones: PagaduriaCondicion[] = [];
  // variables calendario
  minFechaInicial: Date;
  calPropiedades: CalendarioPropiedades = new CalendarioPropiedades();

  parametro: number;
  formula: string;
  formulaCupo: string;

  constructor(
    private ref: DynamicDialogRef,
    private fb: FormBuilder,
    private navServicio: NavService,
    private lisServicio: ListaService,
    private confirmationService: ConfirmationService,
    private config: DynamicDialogConfig,
    private pagaduriaCondicionService: PagaduriasCondicionesService,
    private pagaduriasCondicionesHistoricosService: PagaduriasCondicionesHistoricosService
  ) { }

  async ngOnInit() {
    this.detalle = this.config.data.detalle;
    this.comparacion = this.config.data.comparacion;
    this.pagaduriaCondicion = this.config.data.pagaduriaCondicion;
    this.pagaduria = this.config.data.pagaduria;
    this.listadoPagaduriasCondiciones =
      this.config.data.listadoPagaduriasCondiciones;
    this.minFechaInicial = new Date();
    this.calPropiedades.actualizarRango(80);
    this.setColumnasTabla();
    await this.cargarInformacionInicial();
    if (this.comparacion) {
      this.obtenerPagaduriaCondicionActiva();
    }
    this.cargarFormulario();
  }

  async cargarInformacionInicial() {
    // this.listaMetodosCalculosTodos = await this.lisServicio.getMasterDetails("ListasMetodosCalculosCupos").toPromise();
    // this.listaTiempoDesfasesPagaduriasTodos = await this.lisServicio.getMasterDetails("ListasTiemposDesfasesPagadurias").toPromise();
    // this.listaTiposFirmasAutorizacionesTodos = await this.lisServicio.getMasterDetails("ListasTiposFirmasAutorizaciones").toPromise();

    forkJoin(
      this.lisServicio.getMasterDetails("ListasMetodosCalculosCupos"),
      this.lisServicio.getMasterDetails("ListasTiemposDesfasesPagadurias"),
      this.lisServicio.getMasterDetails("ListasTiposFirmasAutorizaciones")
    ).subscribe(
      async ([
        lisMetodosCalculosCupo,
        lisTiemposDesfasesPagadurias,
        lisTiposFirmasAutorizaciones,
      ]) => {
        if (this.pagaduriaCondicion) {
          const pagaduriaCondicionHistoricos = await this.pagaduriasCondicionesHistoricosService.listadoPorIdPagaduriaCondicion(this.pagaduriaCondicion.idPagaduriaCondicion).toPromise();
          this.pagaduriasCondicionesHistoricos = (pagaduriaCondicionHistoricos).sort(function (a, b) {
            if (a.version > b.version) {
              return -1;
            } else {
              return 1;
            }
          });
        }
        if (this.comparacion) {
          this.obtenerPagaduriaCondicionActiva();
        }
        this.listaMetodosCalculosTodos = lisMetodosCalculosCupo;
        this.listaTiempoDesfasesPagaduriasTodos = lisTiemposDesfasesPagadurias;
        this.listaTiposFirmasAutorizacionesTodos = lisTiposFirmasAutorizaciones;

        this.listaMetodosCalculosTodos.map((s: ListaItem) => {
          this.lisMetodosCalculoCupo.push({
            label: s.nombre,
            value: s.idLista,
          });
        });

        this.listaTiempoDesfasesPagaduriasTodos.map((s: ListaItem) => {
          this.lisTiempoDesfasesPagadurias.push({
            label: s.nombre,
            value: s.idLista,
          });
        });

        this.listaTiposFirmasAutorizacionesTodos.map((s: ListaItem) => {
          this.lisTiposFirmasAutorizaciones.push({
            label: s.nombre,
            value: s.idLista,
          });
        });
        if (this.detalle) this.validarCamposRequeridos();
        this.carTabla = false;
        this.cargandoInformacion = false;
      }
    );

  }

  sumarDias(fecha, dias) {
    fecha.setDate(fecha.getDate() + dias);
    return fecha;
  }

  setColumnasTabla() {
    this.columnas = [
      {
        field: "consecutivo",
        header: this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_CONSECUTIVO"
        ),
        sort: false,
      },
      {
        field: "fecha",
        header: this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_FECHA"
        ),
        sort: false,
      },
      {
        field: "hora",
        header: this.navServicio.buscarMensaje("PAGADURIACONDICIONES.LBL_HORA"),
        sort: false,
      },
      {
        field: "usuarioConfigura",
        header: this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_USUARIOCONFIGURA"
        ),
        sort: false,
      },
      {
        field: "usuarioAprueba",
        header: this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_USUARIOAPRUEBA"
        ),
        sort: false,
      },
      {
        field: "usuarioModifica",
        header: this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_USUARIOMODIFICA"
        ),
        sort: false,
      },
      {
        field: "ipPublica",
        header: this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_IPPUBLICA"
        ),
        sort: false,
      },
      {
        field: "ipPrivada",
        header: this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_IPPRIVADA"
        ),
        sort: false,
      },
      {
        field: "estado",
        header: this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.LBL_ESTADO"
        ),
        sort: false,
      },
    ];
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      idPagaduria: [this.pagaduria ? this.pagaduria.idPagaduria: null],
      version: [
        this.pagaduriaCondicion ? this.pagaduriaCondicion.version : null,
      ],
      fechaInicioVigencia: [
        this.pagaduriaCondicion
          ? this.pagaduriaCondicion.fechaInicioVigencia
          : null,
        [Validators.required],
      ],
      indicadorApruebaLibranza: [
        this.pagaduriaCondicion
          ? this.pagaduriaCondicion.indicadorApruebaLibranza
          : false,
      ],
      diaPago: [
        this.pagaduriaCondicion ? this.pagaduriaCondicion.diaPago : null,
        [Validators.required],
      ],
      diaCorte: [
        this.pagaduriaCondicion ? this.pagaduriaCondicion.diaCorte : null,
        [Validators.required],
      ],
      idDesfaseAntesCorte: [
        this.pagaduriaCondicion
          ? this.pagaduriaCondicion.idDesfaseAntesCorte
          : null,
        [Validators.required],
      ],
      desfaseAntesCorte: [
        this.pagaduriaCondicion
          ? this.pagaduriaCondicion.desfaseAntes
          : null,
      ],
      idDesfaseDespuesCorte: [
        this.pagaduriaCondicion
          ? this.pagaduriaCondicion.idDesfaseDespuesCorte
          : null,
        [Validators.required],
      ],
      desfaseDespuesCorte: [
        this.pagaduriaCondicion
          ? this.pagaduriaCondicion.desfaseDespues
          : null,
      ],
      idMetodoFirma: [
        this.pagaduriaCondicion ? this.pagaduriaCondicion.idMetodoFirma : null,
        [Validators.required],
      ],
      idMetodoCalculoCupo: [
        this.pagaduriaCondicion
          ? this.pagaduriaCondicion.idMetodoCalculoCupo
          : null,
        [Validators.required],
      ],
      porcentaje1: [
        this.pagaduriaCondicion ? this.pagaduriaCondicion.porcentaje1 : null,
        [Validators.required],
      ],
      porcentaje2: [
        this.pagaduriaCondicion ? this.pagaduriaCondicion.porcentaje2 : null,
      ],
      porcentajeParametro: [
        this.pagaduriaCondicion ? this.pagaduriaCondicion.porcentajeParametro : null,
      ],
    });
  }

  validarCamposRequeridos() {
    this.metodo = this.listaMetodosCalculosTodos.find(
      (x) => x.idLista === this.f.idMetodoCalculoCupo.value
    );
    switch (this.metodo.codigo) {
      case MetodosCalculoCupo.METODO1:
        this.f.porcentaje2.setValidators([Validators.required]);
        this.f.porcentajeParametro.setValidators([Validators.required]);
        if (!this.detalle) {
          this.f.porcentaje2.setValue(null);
          this.f.porcentaje1.setValue(null);
        }
        break;

      case MetodosCalculoCupo.METODO2:
        this.f.porcentaje2.setValidators([]);
        this.f.porcentajeParametro.setValidators([]);
        if (!this.detalle) {
          this.f.porcentaje2.setValue(null);
          this.f.porcentaje1.setValue(null);
        }
        break;

      case MetodosCalculoCupo.METODO3:
        this.f.porcentaje2.setValidators([]);
        this.f.porcentajeParametro.setValidators([]);
        if (!this.detalle) {
          this.f.porcentaje2.setValue(null);
          this.f.porcentaje1.setValue(null);
        }
        break;

      default:
        break;
    }
  }

  validarDesfaseDespuesCorte() {
    let desfaseAntesCorte;
    let desfaseDespuesCorte;

    if (
      (!this.f.idDesfaseDespuesCorte.value && !this.f.idDesfaseAntesCorte.value) ||
      !this.f.idDesfaseAntesCorte.value
    ) {
      return;
    }

    desfaseAntesCorte = this.listaTiempoDesfasesPagaduriasTodos.find(
      (x) => x.idLista === this.f.idDesfaseAntesCorte.value
    );
    desfaseDespuesCorte = this.listaTiempoDesfasesPagaduriasTodos.find(
      (x) => x.idLista === this.f.idDesfaseDespuesCorte.value
    );

    if (desfaseAntesCorte.nombre === TiemposDesfasesPagadurias.TIEMPO90) {
      return true;
    }

    if (
      Number(desfaseDespuesCorte.nombre) <= Number(desfaseAntesCorte.nombre)
    ) {
      this.navServicio.setMesage(0, {
        severity: "error",
        summary: this.navServicio.buscarMensaje("LBL_INFORMACION"),
        detail: this.navServicio.buscarMensaje(
          "PAGADURIACONDICIONES.MSG_ERRORTIEMPOSDESFASES"
        ),
      });
      return false;
    } else {
      return true;
    }
  }

  validarDesfaseAntesCorte() {
    let desfaseAntesCorte;
    let desfaseDespuesCorte;
    if (!this.f.idDesfaseAntesCorte.value) {
      return;
    }

    desfaseAntesCorte = this.listaTiempoDesfasesPagaduriasTodos.find(
      (x) => x.idLista === this.f.idDesfaseAntesCorte.value
    );
    desfaseDespuesCorte = this.listaTiempoDesfasesPagaduriasTodos.find(
      (x) => x.idLista === this.f.idDesfaseDespuesCorte.value
    );

    if (desfaseAntesCorte.nombre === TiemposDesfasesPagadurias.TIEMPO90) {
      this.f.idDesfaseDespuesCorte.setValue(null);
      this.f.idDesfaseDespuesCorte.setValidators([]);
      this.f.idDesfaseDespuesCorte.disable();
    } else {
      this.f.idDesfaseDespuesCorte.setValue(null);
      this.f.idDesfaseDespuesCorte.setValidators([Validators.required]);
      this.f.idDesfaseDespuesCorte.enable();
    }
  }

  obtenerPagaduriaCondicionActiva() {
    if (
      !this.listadoPagaduriasCondiciones ||
      this.listadoPagaduriasCondiciones.length === 0
    ) {
      return;
    }
    this.pagaduriaCondicionComparar = this.listadoPagaduriasCondiciones.find(
      (x) => x.codigoEstado === CodigosEstadosFuncionalidades.ACTIVO
    );
  }

  get f() {
    return this.formulario.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.formulario.valid) {
      if (this.validarDesfaseDespuesCorte()) {
        this.guardarPagaduriaCondicion();
      } else {
        this.navServicio.setMesage(0, {
          severity: "error",
          summary: this.navServicio.buscarMensaje("LBL_INFORMACION"),
          detail: this.navServicio.buscarMensaje(
            "PAGADURIACONDICIONES.MSG_ERRORTIEMPOSDESFASES"
          ),
        });
      }
    }
  }

  guardarPagaduriaCondicion() {
    this.cargandoInformacion = true;
    const registro: PagaduriaCondicion = this.formulario.getRawValue();
    this.pagaduriaCondicionService
      .crearEspecial(registro)
      .subscribe((pagaduriaCondicion) => {
        this.pagaduriaCondicion = pagaduriaCondicion;
        this.cargandoInformacion = false;
        this.ref.close(true);
      });
  }

  cerrar(fDirty: boolean) {
    if (this.detalle) {
      this.ref.close();
      return;
    }
    if (fDirty) {
      this.confirmationService.confirm({
        message: `No se van a almacenar los campos ¿desea continuar?`,
        header: "Confirmación",
        icon: "fa fa-question-circle",
        accept: () => {
          this.ref.close();
        },
      });
    } else {
      this.ref.close();
    }
  }

  preCargarParametro() {
    this.parametro = this.f.porcentajeParametro.value;
  }
}
